import React from 'react';
import { Check } from 'lucide-react';

const StepIndicator = ({ currentStep, totalSteps = 3, showDetailsStep = false }) => {
  // Dynamic steps based on whether details step is needed
  const steps = showDetailsStep
    ? [
        { num: 1, label: 'Select Service' },
        { num: 2, label: 'Select Company' },
        { num: 3, label: 'Details' },
        { num: 4, label: 'Payment' },
      ]
    : [
        { num: 1, label: 'Select Service' },
        { num: 2, label: 'Select Company' },
        { num: 3, label: 'Payment' },
      ];

  const displaySteps = steps.slice(0, showDetailsStep ? 4 : totalSteps);

  return (
    <div className="flex items-center justify-center mb-8">
      {displaySteps.map((step, index) => (
        <React.Fragment key={step.num}>
          {/* Step Circle */}
          <div className="flex flex-col items-center">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-colors ${
                step.num < currentStep
                  ? 'bg-[#059669] text-gray-900'
                  : step.num === currentStep
                  ? 'bg-[#059669] text-gray-900'
                  : 'bg-gray-800 text-gray-400'
              }`}
            >
              {step.num < currentStep ? (
                <Check className="w-5 h-5" />
              ) : (
                step.num
              )}
            </div>
            <span
              className={`mt-2 text-xs ${
                step.num <= currentStep ? 'text-white' : 'text-gray-500'
              }`}
            >
              {step.label}
            </span>
          </div>

          {/* Connector Line */}
          {index < displaySteps.length - 1 && (
            <div
              className={`w-16 md:w-24 h-0.5 mx-2 ${
                step.num < currentStep ? 'bg-[#059669]' : 'bg-gray-800'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;
